/**
 * @owner @Appboy/whats-app
 */

// generated from 48 samples

import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const tiktokAudienceSyncStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("TIKTOK_AUDIENCE_SYNC"),
  step_data: z.object({
    action: z.literal("add_users"),
    // null: 7 (14.58%)
    ad_account_id: z.string().nullable(),
    app_group_id: common.objectId,
    bulk_flusher_rate_limit_violation: z.literal(false),
    canvas_id: common.objectId,
    // null: 7 (14.58%)
    // format integer: 40 (97.56%)
    custom_audience_id: z.string().nullable(),
    custom_audience_name: z.literal(""),
    fields_to_match: z.array(z.string()),
    intent: z.enum(["sync_to_existing", "create_new"]),
  }),
});
